// extracted by mini-css-extract-plugin
module.exports = {"jobItem":"JobItem_jobItem__1783Q","jobTitle":"JobItem_jobTitle__1e-bP","jobLine":"JobItem_jobLine__3Rj9c","jobButton":"JobItem_jobButton__1Ps9_"};